/* @flow */

const hooks: Object = {
  onInit(form: Object) {
    // override default bindings for all text inputs
    // (this.name === 'Register Material') &&
    //     this.each((field: Object) => field.type === 'text' &&
    //         field.set('bindings', 'TextField'));
  },

  onSuccess(form: Object) {
    console.log('Form Values', form.values());
  },

  onError(form: Object) {
    console.log('Form Errors', form.errors());
  },

  onSubmit(instance: Object) {
    console.log('Form Errors', instance.errors());
    console.log('-> onSubmit HOOK -', instance.path || 'form', '- isValid?', instance.isValid);
  },

  onClear(instance: Object) {
    console.log('-> onClear HOOK -', instance.path || 'form');
  },

  onReset(instance: Object) {
    console.log('-> onReset HOOK -', instance.path || 'form');
  },

  onChange(field: Object) {
    console.log('-> onChange HOOK -', field.path, field.value);
  },

  onFocus: (field: Object) => {
    console.log('-> onFocus HOOK -', field.path, field.value);
  },

  onBlur: (field: Object) => {
    console.log('-> onBlur HOOK -', field.path, field.value);
  },
};

export default hooks;
